module.exports = __webpack_public_path__ + "static/media/eren.37a1a7ba.jpg";